import React from "react";
import { connect } from "react-redux";
import routes from "../../../assets/apiRoutes.json"
import axios from "axios";
import { GridLayout } from "../../../common/GridLayout";

import DataGrid, {
  Column,
  Editing,
  Paging,
  Selection,
  Toolbar,
  Item,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnFixing,
  Sorting,
  Export,
  Pager,
  HeaderFilter,
  StateStoring
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { alert } from 'devextreme/ui/dialog';
import { confirm } from 'devextreme/ui/dialog';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";

const filterBuilderPopupPosition = {
  of: window,
  at: 'top',
  my: 'top',
  offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const dataGrid = React.createRef();
let accessToken = '';

const gridKey = "cf3da376-9da7-449b-b036-5b530eb1c8d9";
class EditStratificationDates extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedItemKeys: [],
      currentLayout: "Default",
    };

    accessToken = props.oidc.user.access_token;
    this.selectionChanged = this.selectionChanged.bind(this);
    this.deleteRecords = this.deleteRecords.bind(this);
    this.onContentReady = this.onContentReady.bind(this);
    this.AddYear = this.AddYear.bind(this);
    this.SubtractYear = this.SubtractYear.bind(this);
    this.dataSource = createStore({
      key: 'rowid',
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.maintenance.AllStratificationDates}`,
      insertUrl: `${window._env_.REACT_APP_APIS}/${routes.maintenance.InsertStratificationDate}`,
      updateUrl: `${window._env_.REACT_APP_APIS}/${routes.maintenance.UpdateStratificationDate}`,
      deleteUrl: `${window._env_.REACT_APP_APIS}/${routes.maintenance.DeleteStratificationDate}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
  }
  loadState = () => {return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null, this.state.currentLayout);}
  saveState=(state)=> { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);}
   setCurrentLayout =(value)=>{
    this.setState({
      currentLayout:value
    })
  }
  render() {
    return (
      <div className="h-100 m-0" style={{ height: '100%', overflowY: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <DataGrid
          style={{ flex: '1 1 auto', minHeight: 0 }}

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
          onContentReady={this.onContentReady}
          ref={dataGrid}
          showBorders={true}
          className="ATConfigurationGridStyle"
          selectedRowKeys={this.state.selectedItemKeys}
          onSelectionChanged={this.selectionChanged}
          rowAlternationEnabled={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
        >
          <Selection mode="multiple" />
          <Paging
            enabled={true}
          />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <FilterBuilderPopup position={filterBuilderPopupPosition} />
          <ColumnChooser
            enabled={true}
            allowSearch={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          />
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true}/>,
          <Export enabled={true} allowExportSelectedData={true} text="Export" />
          <Sorting mode="multiple"/>
          <Editing
            mode="cell"
            newRowPosition="first"
            refreshMode="repaint"
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true} />
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={this.loadState}
            storageKey={gridKey}
            customSave={this.saveState}
          />
          <Column dataField="species" caption="Species"/>
          <Column dataField="speciescode" caption="Species Code"/>
          <Column dataField="celltype"  caption="Cell Type"/>
          <Column dataField="cellsize" dataType="number" caption="Cell Size"/>
          <Column dataField="site" caption="Site"/>
          <Column dataField="drytreat" dataType="number" caption="Dry Treat"/>
          <Column dataField="stratdays" dataType="number" caption="Strat Days" allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="wetstratdays" dataType="number" caption="Wet Days"/>
          <Column dataField="drystratdays" dataType="number" caption="Dry Days"/>
          <Column dataField="shipdays" dataType="number" caption="Ship Days"/>
          <Column dataField="plandays" dataType="number" caption="Plan Days"/>
          <Column dataField="sowdate" dataType="date" caption="Sow Date"/>
          <Column dataField="fdsdate"  dataType="date" caption="FDS Date" allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="ordersduedate" caption="Orders Due Date" allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="stratdate" dataType="date" caption="Strat Date" allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="keycode"  caption="Key Code" allowEditing={false} cssClass="column-readonly"/>
          <Toolbar>
            <Item location="before">
              <Button onClick={this.AddYear} text="Add a Year" type="default" stylingMode="contained" className="margin-right"/>
            </Item>
            <Item location="before">
              <Button onClick={this.SubtractYear} text="Subtract a Year" type="default" stylingMode="contained"/>
            </Item>
            <Item name="addRowButton"/>
            <Item>
              <Button
                onClick={this.deleteRecords}
                icon="trash"
                disabled={!this.state.selectedItemKeys.length}/>
            </Item>
            <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
                 </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton"/>
          </Toolbar>
        </DataGrid>
      </div>
    );
  }

  onContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.dataSource);
    }
  }

  deleteRecords()
  {
    var that = this;
    let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
    result.then((dialogResult) => {
        if(dialogResult)
        {
          dataGrid.current.instance().beginCustomLoading("Deleting");
          axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.maintenance.DeleteStratificationDates}`,
            that.state.selectedItemKeys,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            dataGrid.current.instance().endCustomLoading();
            dataGrid.current.instance().refresh();
          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

        }
    });

  }

  AddYear() {
    let result = confirm("<i>This will change dates. Do you wish to conitnue?</i>", "Add a Year");
    result.then((dialogResult) => {
        if(dialogResult)
        {

          dataGrid.current.instance().beginCustomLoading("Updating");
          axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.maintenance.StratificationDateAddYear}`,
            {},
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            dataGrid.current.instance().endCustomLoading();
            dataGrid.current.instance().refresh();
          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

        }
    });
  }

  SubtractYear() {
    let result = confirm("<i>This will change dates. Do you wish to conitnue?</i>", "Subtract a Year");
    result.then((dialogResult) => {
        if(dialogResult)
        {
          dataGrid.current.instance().beginCustomLoading("Updating");
          axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.maintenance.StratificationDateSubtractYear}`,
            {},
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            dataGrid.current.instance().endCustomLoading();
            dataGrid.current.instance().refresh();
          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

        }
    });
  }

  selectionChanged(data) {
    this.setState({
      selectedItemKeys: data.selectedRowKeys,
    });
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(EditStratificationDates);
